// Agent Marketing - FAQ data

export const faqs = [
  {
    q: "What does Agent Marketing do?",
    a: "Agent Marketing builds professional branding, websites, Google presence, business email, social assets, listing templates, automation, and growth systems for agents and agencies that want to compete seriously.",
  },
  {
    q: "Who is Agent Marketing for?",
    a: "Real estate agents, mortgage professionals, insurance agents, recruiters, talent agents, financial advisors, sales professionals, and the agencies and brokerages that employ them. If your business depends on trust, reputation, and first impressions, this is built for you.",
  },
  {
    q: "Is Agent Marketing a separate company?",
    a: "Agent Marketing is a branded division of Kostaja Ltd. Agent Marketing is the service brand focused on professional presence, marketing systems, and growth support for agents and agencies. Kostaja Ltd. is the official company behind the brand.",
  },
  {
    q: "What is Kostaja Ltd.?",
    a: "Kostaja Ltd. is the official company behind Agent Marketing. All legal, ownership, privacy, and terms documentation refers to Kostaja Ltd. Learn more at kostaja.ca.",
  },
  {
    q: "Do you only work with real estate agents?",
    a: "No. We serve real estate, mortgage, insurance, recruiting, talent, financial services, and other professional service businesses that rely on trust and referrals.",
  },
  {
    q: "What if I am a new agent?",
    a: "The Foundation package was built for this. It gives you a professional logo, business email, Google profile, social banners, and business card so you look established from day one.",
  },
  {
    q: "What if I already have a website?",
    a: "We can review it, upgrade it, or replace it. Many clients start with a growth assessment so we can identify what should stay, what should change, and what should be rebuilt.",
  },
  {
    q: "Can you help if my branding is outdated?",
    a: "Yes. Branding refresh is one of the most common starting points. We rebuild the logo, colours, typography, and asset system so everything looks like it belongs to the same business.",
  },
  {
    q: "Do you build websites?",
    a: "Yes. Fast, mobile-first websites with clear service pages, lead capture, SEO foundations, and analytics. Ongoing management is included in monthly plans.",
  },
  {
    q: "Do you manage Google Business Profiles?",
    a: "Yes. Setup, optimization, categories, service descriptions, photos, posting, and review support.",
  },
  {
    q: "Do you create listing templates?",
    a: "Yes. Branded template systems for Just Listed, Just Sold, Open House, Price Improvement, For Lease, and more, sized for social, web, print, and paid ads.",
  },
  {
    q: "Do you help agencies and brokerages?",
    a: "Yes. Agency packages cover agency branding, team websites, recruiting funnels, per-agent add-ons, CRM setup, and multi-funnel campaigns.",
  },
  {
    q: "Do you offer AI receptionist systems?",
    a: "Yes. AI receptionist, missed-call text back, lead intake, and follow-up automations that protect the opportunity when you are busy.",
  },
  {
    q: "Do you help with CRM and automation?",
    a: "Yes. Lead capture, routing, follow-up sequences, review requests, pipeline structure, and reporting.",
  },
  {
    q: "Can I start small?",
    a: "Yes. Many clients begin with the Foundation package and add services as they grow.",
  },
  {
    q: "Can I upgrade later?",
    a: "Yes. Every tier is built to grow. Foundation clients often move to Presence, and Presence clients often move to Authority as their business scales.",
  },
  {
    q: "Why not do this myself?",
    a: "You can. It just tends to cost more time and trust than expected. Weak assets built between appointments can quietly make a strong professional look less established than they really are.",
  },
  {
    q: "Why is DIY marketing risky?",
    a: "Because the cost is rarely visible. It shows up as the prospect who liked you but chose someone who looked more prepared, or the referral partner who chose someone easier to send.",
  },
  {
    q: "Do you guarantee leads?",
    a: "No. Results depend on your market, offer, follow-up, and consistency. We build professional infrastructure that supports lead generation, but we do not promise leads or revenue.",
  },
  {
    q: "How long does setup take?",
    a: "Foundation typically launches in one to two weeks. Presence in three to six weeks. Authority is scoped per engagement.",
  },
  {
    q: "How does payment work?",
    a: "Setup fees are due before work begins. Monthly fees are billed at the start of each service period. Custom projects may require 50% upfront and 50% before launch.",
  },
  {
    q: "Do you work outside Canada?",
    a: "Yes. Agent Marketing serves agents and agencies across Canada, the United States, Australia, and England, with a primary focus on Ontario-based professionals and organizations.",
  },
  {
    q: "What happens after I contact you?",
    a: "We review your request and schedule a short fit conversation. We look at your current presence, understand your goals, and recommend the right next step. You do not need to know which package you need before we speak.",
  },
];
